(function () {
  if (!document.querySelector(".grid-product")) return;

  const FRAMES = [
    { key: "negro", label: "Negro", color: "#302E2C", image: "https://cdn.shopify.com/s/files/1/0358/7814/2092/files/negro-frame-texture.jpg?v=1786125214", imageSlice: 50, swatchImage: "https://cdn.shopify.com/s/files/1/0358/7814/2092/files/negro-swatch.jpg?v=1786125214", shadow: "3px 3px 14px rgba(0,0,0,0.5)" },
    { key: "plateado", label: "Plateado", color: "#93938E", image: "https://cdn.shopify.com/s/files/1/0358/7814/2092/files/plateado-frame-texture.jpg?v=1786124121", imageSlice: 122, swatchImage: "https://cdn.shopify.com/s/files/1/0358/7814/2092/files/plateado-swatch.jpg?v=1786124121", shadow: "3px 3px 14px rgba(0,0,0,0.3)" },
    { key: "blanco", label: "Blanco", color: "#F1F0EA", image: "https://cdn.shopify.com/s/files/1/0358/7814/2092/files/blanco-frame-texture.jpg?v=1786125213", imageSlice: 55, swatchImage: "https://cdn.shopify.com/s/files/1/0358/7814/2092/files/blanco-swatch.jpg?v=1786125213", shadow: "3px 3px 14px rgba(0,0,0,0.22)" },
    { key: "dorado", label: "Dorado", color: "#A38F5E", image: "https://cdn.shopify.com/s/files/1/0358/7814/2092/files/dorado-frame-texture.jpg?v=1786116583", imageSlice: 124, swatchImage: "https://cdn.shopify.com/s/files/1/0358/7814/2092/files/dorado-swatch.jpg?v=1786119710", shadow: "3px 3px 14px rgba(0,0,0,0.35)" },
    { key: "natural", label: "Madera Natural", color: "#DFC79E", image: "https://cdn.shopify.com/s/files/1/0358/7814/2092/files/madera-frame-texture.jpg?v=1786125204", imageSlice: 38, swatchImage: "https://cdn.shopify.com/s/files/1/0358/7814/2092/files/madera-swatch.jpg?v=1786125203", shadow: "3px 3px 14px rgba(0,0,0,0.28)" }
  ];

  const checked = new Set();
  let duoHandlesPromise = null;

  function getDuoHandles() {
    if (!duoHandlesPromise) {
      duoHandlesPromise = fetch("/collections/duos/products.json?limit=250")
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (data) { return new Set((data.products || []).map(function (p) { return p.handle; })); })
        .catch(function () { return new Set(); });
    }
    return duoHandlesPromise;
  }

  function borderImageFor(frame) {
    if (frame.image) return "url(" + frame.image + ") " + frame.imageSlice + " stretch";
    if (frame.gradient) return frame.gradient + " 1";
    return "none";
  }

  function swatchBg(frame) {
    if (frame.swatchImage) return "background-image:url(" + frame.swatchImage + ");background-size:cover;background-position:center;";
    if (frame.image) return "background-image:url(" + frame.image + ");background-size:cover;background-position:center;";
    return "background:" + (frame.gradient || frame.color) + ";";
  }

  function applyFrame(mask, frame) {
    mask.style.setProperty("--cfp-color", frame.color);
    mask.style.setProperty("--cfp-border-image", borderImageFor(frame));
    mask.style.setProperty("--cfp-shadow", frame.shadow);
  }

  function fitMaskToImage(mask) {
    const img = mask.querySelector("img");
    const ratioBox = mask.querySelector(".grid__image-ratio");
    if (!img) return;

    function apply() {
      const w = img.naturalWidth || parseFloat(img.getAttribute("width"));
      const h = img.naturalHeight || parseFloat(img.getAttribute("height"));
      if (!w || !h) return;
      const cs = getComputedStyle(mask);
      const padLeft = parseFloat(cs.paddingLeft) || 0;
      const padRight = parseFloat(cs.paddingRight) || 0;
      const padTop = parseFloat(cs.paddingTop) || 0;
      const padBottom = parseFloat(cs.paddingBottom) || 0;
      const borderTop = parseFloat(cs.borderTopWidth) || 0;
      const borderBottom = parseFloat(cs.borderBottomWidth) || 0;
      const contentHeight = (mask.clientWidth - padLeft - padRight) * h / w;
      mask.style.setProperty("height", contentHeight + padTop + padBottom + borderTop + borderBottom + "px", "important");
      if (ratioBox) {
        ratioBox.style.setProperty("height", contentHeight + "px", "important");
        ratioBox.style.setProperty("padding", "0", "important");
      }
    }

    apply();
    if (!img.complete) img.addEventListener("load", apply, { once: true });
    window.addEventListener("resize", apply);
  }

  function isFrameableVariant(v) {
    return [v.option1, v.option2, v.option3].some(function (o) { return o && /con marco/i.test(o); });
  }

  function formatCLP(cents) {
    return "$" + Math.round(cents / 100).toLocaleString("es-CL");
  }

  function updateCardPrice(card, variant) {
    const priceEl = card.querySelector(".grid-product__price");
    if (!priceEl) return;
    const original = priceEl.querySelector(".grid-product__price--original");
    const savings = priceEl.querySelector(".grid-product__price--savings");
    const hasCompareAt = variant.compare_at_price && variant.compare_at_price > variant.price;

    const currentNode = Array.prototype.find.call(priceEl.childNodes, function (n) {
      return n.nodeType === 3 && n.textContent.indexOf("$") !== -1;
    });
    if (currentNode) currentNode.textContent = formatCLP(variant.price);

    if (hasCompareAt) {
      if (original) {
        original.textContent = formatCLP(variant.compare_at_price);
        original.style.display = "";
      }
      if (savings) {
        const pct = Math.round((1 - variant.price / variant.compare_at_price) * 100);
        savings.textContent = pct + "% OFF";
        savings.style.display = "";
      }
    } else {
      if (original) original.style.display = "none";
      if (savings) savings.style.display = "none";
    }
  }

  function setupFramedCard(card, mask, wrapper, link, frameVariant) {
    mask.classList.add("cfp-framed");
    fitMaskToImage(mask);

    if (frameVariant) {
      updateCardPrice(card, frameVariant);
      if (link) {
        try {
          const url = new URL(link.href);
          url.searchParams.set("variant", frameVariant.id);
          link.href = url.toString();
        } catch (e) {}
      }
    }

    if (card.querySelector(".cfp-swatches")) return;

    const wrap = document.createElement("div");
    wrap.className = "cfp-swatches";
    FRAMES.forEach(function (frame, i) {
      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "cfp-swatch" + (i === 0 ? " cfp-active" : "");
      btn.title = frame.label;
      btn.dataset.key = frame.key;
      btn.innerHTML = '<span class="cfp-swatch-dot" style="' + swatchBg(frame) + '"></span>';
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        applyFrame(mask, frame);
        wrap.querySelectorAll(".cfp-swatch").forEach(function (b) { b.classList.remove("cfp-active"); });
        btn.classList.add("cfp-active");
      });
      wrap.appendChild(btn);
    });
    wrapper.insertAdjacentElement("afterend", wrap);
  }

  function injectCard(card) {
    const wrapper = card.querySelector(".grid__item-image-wrapper");
    const mask = card.querySelector(".grid-product__image-mask");
    if (!wrapper || !mask || checked.has(card)) return;
    checked.add(card);

    const link = card.querySelector(".grid-product__link, a[href*='/products/']");
    if (!link) return;
    let handle;
    try {
      handle = new URL(link.href).pathname.split("/products/")[1];
      if (handle) handle = handle.split("?")[0].split("/")[0];
    } catch (e) {
      return;
    }
    if (!handle) return;

    Promise.all([
      fetch("/products/" + handle + ".js").then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; }),
      getDuoHandles()
    ]).then(function (results) {
      const product = results[0];
      const duoHandles = results[1];
      if (!product || !product.variants) return;
      if (duoHandles.has(handle)) return;
      const frameVariant = product.variants.find(isFrameableVariant);
      if (frameVariant) setupFramedCard(card, mask, wrapper, link, frameVariant);
    });
  }

  function injectAll() {
    document.querySelectorAll(".grid-product").forEach(injectCard);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", injectAll);
  } else {
    injectAll();
  }

  const grid = document.querySelector(".collection, .grid--view-items, main") || document.body;
  new MutationObserver(injectAll).observe(grid, { childList: true, subtree: true });
})();
